import { render, staticRenderFns } from "./CatParts.vue?vue&type=template&id=05e1e02f&"
import script from "./CatParts.vue?vue&type=script&lang=js&"
export * from "./CatParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports